"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetShoppingPricesInputSchema = exports.ShoppingRetailerSchema = void 0;
const zod_1 = require("zod");
exports.ShoppingRetailerSchema = zod_1.z.object({
    /** Merchant name (e.g., "Sephora", "Amazon") */
    name: zod_1.z.string(),
    /** Product title from Google Shopping (e.g., "CeraVe Foaming Cleanser 16 oz") */
    productTitle: zod_1.z.string(),
    /** Numeric price (e.g., 12.99) */
    price: zod_1.z.number(),
    /** ISO 4217 currency code (e.g., "USD", "AUD") */
    currency: zod_1.z.string(),
    /** Direct product link from Google Shopping */
    url: zod_1.z.string(),
});
exports.GetShoppingPricesInputSchema = zod_1.z.object({
    productName: zod_1.z.string().min(1).max(200),
    brandName: zod_1.z.string().nullable().optional(),
    /** PDB product ID — enables Google Shopping product ID caching */
    productId: zod_1.z.number().optional(),
});
//# sourceMappingURL=shopping.js.map